export type StoredTeamRead = {
  teamId: number;
  /** True when the stored team belongs to somebody else and should be dropped. */
  discard: boolean;
};

/**
 * Stable, non-reversible digest of the signed-in user. The record now outlives the session, and
 * storing the raw address would leave the previous person's email in a shared browser after they
 * log out — this only ever needs to answer "same user or not".
 */
export function userFingerprint(email: string | null): string | null {
  if (!email) return null;
  let hash = 5381;
  for (let i = 0; i < email.length; i++) {
    hash = ((hash << 5) + hash + email.charCodeAt(i)) | 0;
  }
  return String(hash);
}

export function readStoredTeamId(rawTeam: string | null, currentUser: string | null): StoredTeamRead {
  const teamRef = JSON.parse(rawTeam || '{}');
  const currentRef = userFingerprint(currentUser);

  // Only a POSITIVE mismatch discards: `user_email` is absent between logout and the next
  // `setSession`, and that gap must not read as "somebody else" — it is the window the old expiry
  // check got wrong. TeamProvider re-consults once identity exists, which is what covers the
  // different-person case this deliberately lets through.
  if (teamRef.userRef && currentRef && teamRef.userRef !== currentRef) {
    return { teamId: 0, discard: true };
  }

  return { teamId: teamRef.teamId || 0, discard: false };
}
